// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"749413a0","387":"ac88a9cf","453":"ac93f4d9","524":"3119f743","914":"deb9d97e"}[chunkId] + ".chunk.js";
};